// Complimentary access: entitlement that does NOT come from a Stripe charge.
//
// Staff and comped accounts have their limits and roles set by hand and never
// buy a subscription, so every billing-derived gate (the dashboard's
// get-started lock, the sidebar padlocks) treated them as free users and shut
// them out of a product they are supposed to administer.
//
// The marker is the "Paid Member" Auth0 role. user-manager grants it ONLY
// from reAssignUserRoles, which is reachable only through IntEnableUser —
// called by billing-manager-worker on subscription activation — and strips it
// again on cancellation. No signup path assigns it. So for a real customer
// the role and billing already agree, and the only accounts this changes are
// the ones granted the role by hand.
export const COMPLIMENTARY_ROLE = 'Paid Member';

/**
 * True when the account may use the product without billing saying so.
 * @param roles auth/JWT roles (e.g. user.roles)
 */
export const hasComplimentaryAccess = (roles?: string[]): boolean => !!roles?.includes(COMPLIMENTARY_ROLE);
